import React from "react"
import { Link } from "react-router-dom"
import Footer from "../components/footer"
import Navbar from "../components/nav"

function Jobyne() {
  return (
    <>
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
        <div id="home" className="header-hero bg_cover d-lg-flex align-items-center">
          <div className="shape shape-1" />
          <div className="shape shape-2" />
          <div className="shape shape-3" />
          <div className="shape shape-4" />
          <div className="shape shape-5" />
          <div className="shape shape-6" />
          <div className="container">
            <div className="row align-items-center justify-content-center justify-content-lg-between">
              <div className="col-lg-6 col-md-10">
                <div className="header-hero-content">
                  <h3
                    className="header-title wow fadeInLeftBig"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.2s"
                  >
                    <span>Jobyne</span> US Job Search
                  </h3>
                  <p
                    className="text wow fadeInLeftBig"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.6s"
                  >
                    Find your next job in the United States. Search millions of openings,
                    filter by location, salary, remote work and job type, save your favorite
                    roles and apply faster with a clean, distraction-free experience.
                  </p>
                  <ul className="d-flex">
                    <li>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.jobyne"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="main-btn wow fadeInLeftBig"
                        data-wow-duration="1.3s"
                        data-wow-delay="0.8s"
                      >
                        <img src="assets/images/play-store.png" alt="Download on Play Store" />
                      </a>
                    </li>
                  </ul>
                  <div className="mt-4 wow fadeInLeftBig" data-wow-duration="1.3s" data-wow-delay="0.9s">
                    <Link to="/jobyne/privacy-policy" className="mr-4" style={{ color: "#0898e7", fontWeight: "600" }}>
                      Privacy Policy
                    </Link>
                    <Link to="/jobyne/terms-and-conditions" style={{ color: "#0898e7", fontWeight: "600" }}>
                      Terms & Conditions
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-10">
                <div className="header-image">
                  <img src="assets/images/jobyne.png" alt="Jobyne App" className="image" style={{ borderRadius: "20px", boxShadow: "0 10px 30px rgba(0,0,0,0.15)" }} />
                </div>
              </div>
            </div>
          </div>
          <div className="header-shape-1" />
          <div className="header-shape-2">
            <img src="assets/images/header-shape-2.svg" alt="shape" />
          </div>
        </div>
      </header>

      <Footer />
    </>
  )
}

export default Jobyne